import { FC, useEffect, useRef, useState } from "react";
import cls from "classnames";
import style from "./style.module.scss";
import { callback, getAssetsAnimation, getAssetsIcon } from "../../../utilities";
import { useCallback } from "react";
import { animated, useSpring, AsyncResult, Controller, Lookup } from "@react-spring/web";
import { Player } from "@lottiefiles/react-lottie-player";

const springCallback = () => ({});
const wait = async (animations: AsyncResult<Controller<Lookup<any>>>[]): Promise<void> => {
  await Promise.all(animations);
};

export interface PreviewExlorerProps {
  isShown: boolean;
  isFirst?: boolean;
  onClick?: () => void;
}

export type Display = "block" | "none";

const PreviewExplorer: FC<PreviewExlorerProps> = ({ isShown = false, isFirst = false, onClick = callback }) => {
  const [preview, previewApi] = useSpring(springCallback);
  const [display, setDisplay] = useState<Display>("block");
  const [opacity, setOpacity] = useState<number>(1);

  const show = useCallback(async () => {
    await wait(
      previewApi.start({
        config: { duration: 1000 },
        from: {
          opacity: 0,
          zIndex: 100,
        },
        to: {
          opacity: 1,
          zIndex: 200,
        },
      })
    );

    setDisplay("block");
    if (!playerRef.current) {
      return;
    }
    playerRef.current.setSeeker(0);
    playerRef.current.play();
  }, [previewApi]);

  const hide = useCallback(async () => {
    await wait(
      previewApi.start({
        config: { duration: 1000 },
        from: {
          opacity: 1,
          zIndex: 200,
        },
        to: {
          opacity: 0,
          zIndex: 100,
        },
      })
    );

    setDisplay("none");
  }, [previewApi]);

  useEffect(() => {
    if (isFirst && !isShown) {
      setOpacity(0);
      return;
    }
    if (!isFirst) {
      setOpacity(1);
    }
    if (isShown) {
      show();
    } else {
      hide();
    }
  }, [isFirst, isShown, show, hide]);

  const playerRef = useRef<Player | null>(null);

  const handlePlayerEvent = useCallback((event: string) => {
    const player: any = playerRef.current;
    const animation: any = player.state.instance;
    if (event === "frame") {
      if (animation.currentFrame > 100) {
        player.pause();
      }
    }
  }, []);

  return (
    <animated.div
      className={cls(style.preview)}
      style={{
        opacity,
        ...preview,
      }}
      onClick={onClick}
    >
      <div className={style.preview__effect} />
      <div className={style.preview__picture}>
        <Player
          ref={playerRef}
          keepLastFrame={true}
          src={getAssetsAnimation("explore-template.json")}
          style={{
            display,
            position: "absolute",
            top: "-65px",
            left: "0px",
            width: "480px",
            height: "230px",
          }}
          rendererSettings={{
            viewBoxSize: "0 0 480 230",
          }}
          onEvent={handlePlayerEvent}
        />
      </div>
      <div className={style.preview__text}>
        <span>Explore Templates</span>
        <img className={style.icon} src={getAssetsIcon("dropdown-right.svg")} alt="dropdown right" />
      </div>
    </animated.div>
  );
};

export default PreviewExplorer;
